import styled from 'styled-components';
import GreetingSection from '../../components/navbar/GreetingSection';
import { useTranslation } from 'react-i18next';
import './index.less';
import { InboxHeader } from './components/header';
import { InboxList } from './components/InboxList';
import { useState } from 'react';
const LifePageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
export const LifeInbox = () => {
  const { t } = useTranslation();
  const [searchTerm, setVal] = useState('');
  const [timesp, setTimesp] = useState(0);
  return (
    <LifePageContainer className="life_inbox_container">
      <GreetingSection timesp={timesp} pageName={t('life.inbox.title')} showicon={true} />
      <InboxHeader
        onChange={(e) => {
          setVal(e);
        }}
      />
      <InboxList
        searchTerm={searchTerm}
        onChangeYd={() => {
          setTimesp(new Date().getTime());
        }}
      />
    </LifePageContainer>
  );
};
